export default "__VITE_ASSET__26a0231e__"